var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('b-row',[_c('b-col',{attrs:{"lg":"9","xs":"12"}},[_c('Header'),(_vm.showAvailabilityChecker)?_c('AvailabilityChecker'):_vm._e(),_c('router-view')],1)],1),_c('SocialLinks')],1)}
var staticRenderFns = []

export { render, staticRenderFns }